import { render, staticRenderFns } from "./repayment.vue?vue&type=template&id=4c20b7ec&"
import script from "./repayment.vue?vue&type=script&lang=ts&"
export * from "./repayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports